import { render, staticRenderFns } from "./safOpinionBoard.vue?vue&type=template&id=e65bd52a"
import script from "./safOpinionBoard.vue?vue&type=script&lang=js"
export * from "./safOpinionBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e65bd52a')) {
      api.createRecord('e65bd52a', component.options)
    } else {
      api.reload('e65bd52a', component.options)
    }
    module.hot.accept("./safOpinionBoard.vue?vue&type=template&id=e65bd52a", function () {
      api.rerender('e65bd52a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/sob/safOpinionBoard.vue"
export default component.exports